import { RootPaths } from "@src/appV2/App/paths";
import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";
import {
  SHIFT_DISCOVERY_LIST_PATH,
  SHIFT_DISCOVERY_SHIFT_MODAL_PATH,
  SHIFT_DISCOVERY_WORKPLACE_PROFILE_MODAL_PATH,
  SHIFT_DISCOVERY_WORKPLACE_REVIEWS_COMMENT_MODAL_PATH,
} from "@src/appV2/redesign/ShiftDiscovery/paths";

import { NewsFeedItemPostEvent, NewsFeedItemRecommendationEvent } from "../types";

export function getNewsFeedContentLink(params: {
  event: NewsFeedItemPostEvent | NewsFeedItemRecommendationEvent;
  workplaceId?: string;
  recommendedWorkplaceId?: string;
  commentId?: string;
  shiftId?: string;
}) {
  const {
    event,
    workplaceId = "",
    recommendedWorkplaceId = "",
    shiftId = "",
    commentId = "",
  } = params;

  switch (event) {
    case NewsFeedItemPostEvent.WORKER_RECEIVED_INSTANT_PAY: {
      return `${
        RootPaths.APP_V2_HOME
      }/${SHIFT_DISCOVERY_LIST_PATH}/${SHIFT_DISCOVERY_WORKPLACE_PROFILE_MODAL_PATH.replace(
        ":workplaceId",
        workplaceId ?? ""
      )}`;
    }

    case NewsFeedItemPostEvent.WORKER_REVIEWED_WORKPLACE: {
      return `${
        RootPaths.APP_V2_HOME
      }/${SHIFT_DISCOVERY_LIST_PATH}/${SHIFT_DISCOVERY_WORKPLACE_REVIEWS_COMMENT_MODAL_PATH.replace(
        ":workplaceId",
        workplaceId
      ).replace(":commentId", commentId)}`;
    }

    case NewsFeedItemPostEvent.WORKER_BOOKED_SHIFT_AT_WORKPLACE_WITH_OPENINGS: {
      return `${
        RootPaths.APP_V2_HOME
      }/${SHIFT_DISCOVERY_LIST_PATH}/${SHIFT_DISCOVERY_SHIFT_MODAL_PATH.replace(
        ":shiftId",
        shiftId
      )}`;
    }

    // placeholder
    case NewsFeedItemPostEvent.REFERRED_NEW_WORKER_JOINED: {
      return `${
        RootPaths.APP_V2_HOME
      }/${SHIFT_DISCOVERY_LIST_PATH}/${SHIFT_DISCOVERY_SHIFT_MODAL_PATH.replace(
        ":shiftId",
        shiftId
      )}`;
    }

    // placeholder
    case NewsFeedItemRecommendationEvent.FRIEND_RECOMMENDATION: {
      return `${
        RootPaths.APP_V2_HOME
      }/${SHIFT_DISCOVERY_LIST_PATH}/${SHIFT_DISCOVERY_SHIFT_MODAL_PATH.replace(
        ":shiftId",
        shiftId
      )}`;
    }

    case NewsFeedItemRecommendationEvent.WORKPLACE_RECOMMENDATION: {
      return `${
        RootPaths.APP_V2_HOME
      }/${SHIFT_DISCOVERY_LIST_PATH}/${SHIFT_DISCOVERY_WORKPLACE_PROFILE_MODAL_PATH.replace(
        ":workplaceId",
        recommendedWorkplaceId
      )}`;
    }

    default: {
      logError(APP_V2_APP_EVENTS.UNSUPPORTED_NEWS_FEED_EVENT, {
        error: "Unsupported news feed event",
        metadata: { event },
      });
      return "";
    }
  }
}
